import React, { FC } from 'react';
import cls from 'classnames';
import { RadioItemProps, ContentPadding } from './RadioItem.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import Radio from '../../control/radio/Radio';

export const classNames = getClassNames('sds-radio-item', ['content', 'header', 'body']);

const mapPaddingToClassName: Record<ContentPadding, string> = {
	small: 'pr-contentSmall pl-content3XS',
	medium: 'pr-contentMedium pl-contentXS',
};

const RadioItem: FC<RadioItemProps> = (props) => {
	const {
		className,
		header,
		body,
		contentPadding="medium",
		variant = { type: 'text' },
		...radioProps
	} = props;

	function renderRightColumn() {
		if (variant.type === 'text') {
			return <div className="self-start flex-1">{variant.rightText}</div>;
		} else if (variant.type === 'badge') {
			return <span>{variant.badge}</span>;
		}
		return;
	}

	return (
		<div className={cls(getRootClassListFromProps(classNames, props), className, mapPaddingToClassName[contentPadding])}>
			<Radio {...radioProps}>
				<div className="label">
					<div className={classNames.content}>
						{header && <p className={classNames.header}>{header}</p>}
						{body && <p className={classNames.body}>{body}</p>}
					</div>
					{renderRightColumn()}
				</div>
			</Radio>
		</div>
	);
};

RadioItem.displayName = 'RadioItem';

export default RadioItem;
